// assets/ecomific-region-core.js
// Canonical shipping location + region. Event + storage driven; no globals.
// Precedence: manual > persisted > geo (once) > default.
// alignDomain() implemented but not wired (Slice 2).

(function () {
  'use strict';

  if (window.__ECOMIFIC_REGION_CORE_INIT__) {
    return;
  }
  window.__ECOMIFIC_REGION_CORE_INIT__ = true;

  var VALID_REGIONS = ['east', 'west'];
  var VALID_COUNTRIES = ['ca', 'us'];
  var DEFAULT_REGION = 'east';
  var DEFAULT_COUNTRY = 'ca';
  var READY_EVENT = 'ecomific:region:ready';
  var CHANGE_EVENT = 'ecomific:region:changed';
  var SOURCE_UPDATED_EVENT = 'ecomific:region:source-updated';
  var SYNC_FAILED_EVENT = 'ecomific:region:sync-failed';
  var SET_REQUEST_EVENT = 'ecomific:region:set-request';
  var CART_UPDATE_ENDPOINT = '/cart/update.js';
  var COOKIE_NAME = 'ecomific_region';
  var COOKIE_MAX_AGE_DAYS = 365;
  var SHOPPING_LOCATION_COOKIE = 'ecomific_shopping_location';
  var SHOPPING_LOCATION_SOURCE_COOKIE = 'ecomific_shopping_location_source';
  var SCRIPT_SELECTOR = '#ecomific-region-state, script[data-ecomific-region-state]';
  var SOURCE_DEFAULT = 'default';
  var SOURCE_GEO = 'geo';
  var SOURCE_PERSISTED = 'persisted';
  var SOURCE_LIQUID = 'liquid';
  var SOURCE_HANDOFF = 'handoff';
  var SOURCE_MANUAL = 'manual';

  var LS_KEYS = {
    country: 'ecomific_shipping_country',
    province: 'ecomific_shipping_province',
    region: 'ecomific_region',
    source: 'ecomific_region_source',
    geoSeeded: 'ecomific_geo_seeded',
  };

  var REDIRECT_LOCK_KEY = 'ecomific_domain_redirect_lock';
  var REDIRECT_LOCK_MS = 10000;
  var PREVIEW_THEME_KEY = 'ecomific_preview_theme_id';

  var WEST_PROVINCES = ['BC', 'AB', 'MB', 'SK'];
  var KNOWN_LOCATIONS = ['QC', 'ON', 'BC', 'AB', 'MB', 'SK', 'NB', 'NS', 'PE', 'NL', 'TERRITORIES', 'US'];
  var LOG_NS = 'ecomific';
  var MODULE = 'region-core';

  var hasEmittedReady = false;
  var lastSyncedCartRegion = null;
  var syncCartInFlightRegion = null;
  var syncCartInFlightPromise = null;

  function isDebugEnabled() {
    if (typeof window === 'undefined') return false;
    if (window.ecomificDebug === true || window.__ecomificDebug === true) {
      return true;
    }

    try {
      if (window.localStorage && window.localStorage.getItem('ecomific_debug') === '1') {
        return true;
      }
    } catch (e) {}

    try {
      if (window.location && window.location.search) {
        var params = new URLSearchParams(window.location.search);
        if (params.has('ecomificDebug')) {
          return true;
        }
      }
    } catch (e) {}

    return false;
  }

  function fmt(level, msg) {
    return '[' + LOG_NS + '][' + level + '] ' + MODULE + ': ' + msg;
  }

  function logDebug(msg) {
    if (!isDebugEnabled()) return;
    if (typeof console !== 'undefined' && console.debug) {
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift(fmt('debug', msg));
      console.debug.apply(console, args);
    }
  }

  function logInfo(msg) {
    if (!isDebugEnabled()) return;
    if (typeof console !== 'undefined' && console.info) {
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift(fmt('info', msg));
      console.info.apply(console, args);
    }
  }

  function logWarn(msg) {
    if (typeof console !== 'undefined' && console.warn) {
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift(fmt('warn', msg));
      console.warn.apply(console, args);
    }
  }

  function logError(msg) {
    if (typeof console !== 'undefined' && console.error) {
      var args = Array.prototype.slice.call(arguments, 1);
      args.unshift(fmt('error', msg));
      console.error.apply(console, args);
    }
  }

  function getPinnedPreviewThemeId() {
    try {
      return (window.sessionStorage && window.sessionStorage.getItem(PREVIEW_THEME_KEY)) || '';
    } catch (e) {
      return '';
    }
  }

  function pinPreviewThemeIdFromUrl(url) {
    try {
      var id = url && url.searchParams ? url.searchParams.get('preview_theme_id') : '';
      if (id && window.sessionStorage) {
        window.sessionStorage.setItem(PREVIEW_THEME_KEY, id);
      }
    } catch (e) {}
  }

  function ensurePreviewThemeId(url) {
    try {
      if (!url || !url.searchParams) return;
      var existing = url.searchParams.get('preview_theme_id');
      if (existing) return;
      var pinned = getPinnedPreviewThemeId();
      if (!pinned && typeof window.__ECOMIFIC_PREVIEW_THEME_ID__ === 'string') {
        pinned = window.__ECOMIFIC_PREVIEW_THEME_ID__;
      }
      if (pinned) {
        url.searchParams.set('preview_theme_id', pinned);
      }
    } catch (e) {}
  }

  function normalizeRegion(value) {
    if (typeof value !== 'string') return null;
    var n = value.trim().toLowerCase();
    return VALID_REGIONS.indexOf(n) !== -1 ? n : null;
  }

  function normalizeCountry(value) {
    if (typeof value !== 'string') return null;
    var n = value.trim().toLowerCase();
    return VALID_COUNTRIES.indexOf(n) !== -1 ? n : null;
  }

  function normalizeSource(value) {
    if (typeof value !== 'string') return null;
    var n = value.trim().toLowerCase();
    return n || null;
  }

  function sourceToken(value) {
    var normalized = normalizeSource(value);
    if (!normalized) return '';
    var idx = normalized.lastIndexOf(':');
    return idx === -1 ? normalized : normalized.slice(idx + 1);
  }

  function isStrongerSource(incoming, current) {
    var incomingToken = sourceToken(incoming);
    var currentToken = sourceToken(current);

    if (!incomingToken || incomingToken === currentToken) {
      return false;
    }
    return sourcePriority(incomingToken) > sourcePriority(currentToken);
  }

  function sourcePriority(token) {
    if (token === SOURCE_MANUAL || token === SOURCE_HANDOFF) return 40;
    if (token === SOURCE_PERSISTED || token === SOURCE_LIQUID) return 30;
    if (token === SOURCE_GEO) return 20;
    if (token === SOURCE_DEFAULT) return 10;
    return 0;
  }

  function isManualLikeSource(token) {
    return token === SOURCE_MANUAL || token === SOURCE_HANDOFF;
  }

  function getShoppingLocationCandidate() {
    var cookieLocation = getCookie(SHOPPING_LOCATION_COOKIE);
    var mapped = locationToRegionAndCountry(cookieLocation);
    var cookieSource = sourceToken(getCookie(SHOPPING_LOCATION_SOURCE_COOKIE));
    return {
      mapped: mapped,
      source: cookieSource || SOURCE_DEFAULT,
      location: cookieLocation || '',
    };
  }

  function getCookie(name) {
    if (typeof document === 'undefined') return null;
    var pattern = '; ' + document.cookie;
    var parts = pattern.split('; ' + name + '=');
    if (parts.length < 2) return null;
    try {
      return decodeURIComponent(parts.pop().split(';').shift().trim());
    } catch (e) {
      return null;
    }
  }

  function setCookie(name, value) {
    if (typeof document === 'undefined') return;
    var expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_MAX_AGE_DAYS);
    document.cookie =
      name + '=' + encodeURIComponent(value) +
      '; Expires=' + expires.toUTCString() +
      '; Path=/; SameSite=Lax';
  }

  function getLS(key) {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return window.localStorage.getItem(key);
      }
    } catch (e) {}
    return null;
  }

  function setLS(key, value) {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        if (value == null || value === '') {
          window.localStorage.removeItem(key);
        } else {
          window.localStorage.setItem(key, String(value));
        }
      }
    } catch (e) {}
  }

  function locationToRegionAndCountry(locationCode) {
    if (typeof locationCode !== 'string' || !locationCode.trim()) return null;
    var c = locationCode.trim().toUpperCase();
    if (c === 'US') return { region: 'east', country: 'us', province: '' };
    if (WEST_PROVINCES.indexOf(c) !== -1) return { region: 'west', country: 'ca', province: c };
    if (KNOWN_LOCATIONS.indexOf(c) !== -1) return { region: 'east', country: 'ca', province: c };
    return null;
  }

  function parseLiquidState() {
    var el = document.querySelector(SCRIPT_SELECTOR);
    if (!el) return { cart_region: null, customer_region: null, default_province_code: null, customer_logged_in: false };
    try {
      var parsed = JSON.parse(el.textContent || '{}') || {};
      return {
        cart_region: normalizeRegion(parsed.cart_region),
        customer_region: normalizeRegion(parsed.customer_region),
        default_province_code: parsed.default_province_code || null,
        customer_logged_in: !!parsed.customer_logged_in,
      };
    } catch (e) {
      return { cart_region: null, customer_region: null, default_province_code: null, customer_logged_in: false };
    }
  }

  function readPersisted() {
    var region = normalizeRegion(getLS(LS_KEYS.region));
    var country = normalizeCountry(getLS(LS_KEYS.country));
    var province = getLS(LS_KEYS.province) || '';
    var source = getLS(LS_KEYS.source);
    if (region && !country) {
      country = DEFAULT_COUNTRY;
    }
    return { region: region, country: country, province: province, source: source };
  }

  /**
   * Canonical builder used by BOTH boot() and handleSetRequest().
   * Prevents drift between precedence path and manual override path.
   * This function must remain pure and side-effect free.
   */
  function buildCanonicalState(input) {
    if (!input || typeof input !== 'object') return null;
    var region = normalizeRegion(input.region);
    if (!region) return null;
    var country = normalizeCountry(input.country);
    if (!country) {
      country = DEFAULT_COUNTRY;
    }
    var province = (input.province != null && String(input.province).trim()) ? String(input.province).trim() : '';
    var source = input.source || 'persisted';
    return {
      region: region,
      country: country,
      province: province,
      source: source,
    };
  }

  function getGeoCandidate() {
    var cookieVal = getCookie(SHOPPING_LOCATION_COOKIE);
    if (cookieVal) {
      var mapped = locationToRegionAndCountry(cookieVal);
      if (mapped) return mapped;
    }
    if (window.ecomificGeo && typeof window.ecomificGeo === 'object') {
      if (window.ecomificGeo.location) {
        var fromGeo = locationToRegionAndCountry(String(window.ecomificGeo.location));
        if (fromGeo) return fromGeo;
      }
      if (window.ecomificGeo.region) {
        var r = normalizeRegion(String(window.ecomificGeo.region));
        if (r) return { region: r, country: DEFAULT_COUNTRY, province: '' };
      }
    }
    return null;
  }

  function isGeoReadyNow() {
    var cookieVal = getCookie(SHOPPING_LOCATION_COOKIE);
    if (typeof cookieVal === 'string' && cookieVal.trim()) {
      return true;
    }
    if (window.ecomificShoppingLocation && window.ecomificShoppingLocation.initialized) {
      return true;
    }
    var geo = window.ecomificGeo;
    return !!(geo && (geo.location || geo.region));
  }

  function resolveCanonical() {
    var shoppingLocation = getShoppingLocationCandidate();
    if (shoppingLocation.mapped && isManualLikeSource(shoppingLocation.source)) {
      logInfo('resolveCanonical: manual cookie wins', {
        location: shoppingLocation.location,
        source: shoppingLocation.source,
      });
      return {
        region: shoppingLocation.mapped.region,
        country: shoppingLocation.mapped.country,
        province: shoppingLocation.mapped.province || '',
        source: shoppingLocation.source,
      };
    }

    var persisted = readPersisted();
    if (persisted.region) {
      var pCountry = persisted.country || DEFAULT_COUNTRY;
      return {
        region: persisted.region,
        country: pCountry,
        province: persisted.province || '',
        source: sourceToken(persisted.source) || SOURCE_PERSISTED,
      };
    }

    if (shoppingLocation.mapped && shoppingLocation.source === SOURCE_LIQUID) {
      return {
        region: shoppingLocation.mapped.region,
        country: shoppingLocation.mapped.country,
        province: shoppingLocation.mapped.province || '',
        source: SOURCE_LIQUID,
      };
    }

    var geoSeeded = getLS(LS_KEYS.geoSeeded) === '1';
    var hasRegionInLS = !!getLS(LS_KEYS.region);
    if (!geoSeeded && !hasRegionInLS) {
      var geo = getGeoCandidate();
      if (geo) {
        var slSource = shoppingLocation.source;
        var resolvedSource = (slSource && slSource !== SOURCE_DEFAULT) ? slSource : SOURCE_GEO;
        if (resolvedSource === SOURCE_GEO) {
          setLS(LS_KEYS.geoSeeded, '1');
        }
        return { region: geo.region, country: geo.country, province: geo.province || '', source: resolvedSource };
      }
    }

    return { region: DEFAULT_REGION, country: DEFAULT_COUNTRY, province: '', source: 'default' };
  }

  function writeState(state) {
    setLS(LS_KEYS.country, state.country);
    setLS(LS_KEYS.province, state.province || '');
    setLS(LS_KEYS.region, state.region);
    setLS(LS_KEYS.source, state.source);
    setCookie(COOKIE_NAME, state.region);
  }

  function dispatch(name, detail) {
    if (typeof window === 'undefined' || !window.dispatchEvent || typeof window.CustomEvent === 'undefined') return;
    window.dispatchEvent(new CustomEvent(name, { detail: detail }));
  }

  function syncCart(region) {
    if (typeof fetch === 'undefined' || !region) return Promise.resolve();
    if (lastSyncedCartRegion === region) {
      logDebug('Cart sync skipped (already synced this page)', region);
      return Promise.resolve();
    }
    if (syncCartInFlightPromise && syncCartInFlightRegion === region) {
      logDebug('Cart sync skipped (already in-flight)', region);
      return syncCartInFlightPromise;
    }

    var syncPromise = fetch(CART_UPDATE_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: { region: region } }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart update ' + res.status);
        return res.json().catch(function () { return null; });
      })
      .then(function (payload) {
        lastSyncedCartRegion = region;
        return payload;
      })
      .catch(function (err) {
        logWarn('Cart sync failed', err);
        throw err;
      })
      .finally(function () {
        if (syncCartInFlightPromise === syncPromise) {
          syncCartInFlightPromise = null;
          syncCartInFlightRegion = null;
        }
      });

    syncCartInFlightRegion = region;
    syncCartInFlightPromise = syncPromise;
    return syncPromise;
  }

  function emitReady(state, previous) {
    if (hasEmittedReady) return;
    hasEmittedReady = true;
    dispatch(READY_EVENT, {
      region: state.region,
      country: state.country,
      source: state.source,
      province: state.province || undefined,
      previous: previous || undefined,
    });
  }

  function getState() {
    var live = window.ecomificRegionState;
    var canonical = live || buildCanonicalState(resolveCanonical());
    if (!canonical) return null;
    return {
      region: canonical.region,
      country: canonical.country,
      province: canonical.province || '',
      source: canonical.source,
    };
  }

  function emitChanged(state, previous) {
    dispatch(CHANGE_EVENT, {
      region: state.region,
      country: state.country,
      source: state.source,
      province: state.province || undefined,
      previous: previous || undefined,
    });
  }

  function applyCanonical(state, previous, options) {
    logDebug('applyCanonical dispatching READY');
    logDebug('applyCanonical state', state);
    logDebug('applyCanonical previous', previous);
    logDebug('applyCanonical options', options);
    options = options || {};
    writeState(state);
    window.ecomificRegionState = state;
    if (!options.skipEvents && hasEmittedReady && previous && (previous.region !== state.region || previous.country !== state.country)) {
      emitChanged(state, previous);
    }
    syncCart(state.region).then(
      function () {
        emitReady(state);
        logInfo('Cart synced', state.region);
      },
      function (err) {
        emitReady(state);
        dispatch(SYNC_FAILED_EVENT, {
          region: state.region,
          country: state.country,
          source: state.source,
          message: (err && err.message) || 'Cart sync failed',
        });
      }
    );
  }

  function alignDomain(country) {
    if (typeof window === 'undefined' || !window.location) return;
    var c = (country != null && String(country).trim().toLowerCase()) || '';
    if (!c) return;
    var hostname = (window.location.hostname || '').toLowerCase();
    var isCa = hostname === 'upsidedrinks.ca' || hostname === 'www.upsidedrinks.ca';
    var isCom = hostname === 'upsidedrinks.com' || hostname === 'www.upsidedrinks.com';
    var targetOrigin = null;
    if (c === 'us' && isCa) targetOrigin = (window.location.protocol || 'https:') + '//upsidedrinks.com';
    if (c === 'ca' && isCom) targetOrigin = (window.location.protocol || 'https:') + '//upsidedrinks.ca';
    if (!targetOrigin) return;
    var currentUrl = new URL(window.location.href);
    pinPreviewThemeIdFromUrl(currentUrl);
    var targetUrl = new URL(currentUrl.pathname + currentUrl.search + (currentUrl.hash || ''), targetOrigin);
    ensurePreviewThemeId(targetUrl);
    try {
      var lockRaw = window.sessionStorage && window.sessionStorage.getItem(REDIRECT_LOCK_KEY);
      var lock = lockRaw ? (function () { try { return JSON.parse(lockRaw); } catch (e) { return null; } })() : null;
      if (lock && lock.to === targetOrigin && lock.path === currentUrl.pathname && (Date.now() - (lock.ts || 0)) < REDIRECT_LOCK_MS) {
        return;
      }
      if (window.sessionStorage) {
        window.sessionStorage.setItem(REDIRECT_LOCK_KEY, JSON.stringify({
          from: window.location.origin,
          to: targetOrigin,
          path: currentUrl.pathname,
          ts: Date.now(),
        }));
      }
      logInfo('redirect', { from: window.location.href, to: targetUrl.toString() });
      window.location.assign(targetUrl.toString());
    } catch (e) {
      logWarn('alignDomain failed', e);
    }
  }

  function waitForShoppingLocationReady(maxMs) {
    return new Promise(function (resolve) {
      if (typeof window !== 'undefined' && window.ecomificShoppingLocation && window.ecomificShoppingLocation.initialized) {
        resolve({ from: 'shopping-location', already: true });
        return;
      }
      var done = false;
      function onReady() {
        if (done) return;
        done = true;
        window.removeEventListener('ecomific:shopping-location:ready', onReady);
        resolve({ from: 'shopping-location' });
      }
      window.addEventListener('ecomific:shopping-location:ready', onReady);
      setTimeout(function () {
        if (!done) {
          window.removeEventListener('ecomific:shopping-location:ready', onReady);
        }
      }, maxMs);
    });
  }

  function waitForGeoReady(maxMs, intervalMs) {
    return new Promise(function (resolve) {
      var startedAt = Date.now();

      if (isGeoReadyNow()) {
        resolve(true);
        return;
      }

      function tick() {
        if (isGeoReadyNow()) {
          resolve(true);
          return;
        }
        if (Date.now() - startedAt >= maxMs) {
          resolve(false);
          return;
        }
        setTimeout(tick, intervalMs);
      }

      setTimeout(tick, intervalMs);
    });
  }

  function boot() {
    logInfo('boot waiting for geo seed');
    Promise.race([
      waitForShoppingLocationReady(2500),
      waitForGeoReady(2500, 50),
    ]).then(function (result) {
      if (result && result.from === 'shopping-location') {
        logInfo('boot proceeding (shopping-location ready)');
      } else if (result === true) {
        logInfo('boot proceeding (geo ready)');
      } else {
        logInfo('boot proceeding (timeout)');
      }
      var geoReady = (result === true || (result && result.from === 'shopping-location'));
      var resolved = resolveCanonical();
      var canonical = buildCanonicalState(resolved);
      if (!canonical) {
        canonical = buildCanonicalState({
          region: DEFAULT_REGION,
          country: DEFAULT_COUNTRY,
          province: '',
          source: 'default',
        });
      }
      if (canonical && canonical.source === SOURCE_DEFAULT && geoReady === true) {
        var slSource = normalizeSource(getCookie(SHOPPING_LOCATION_SOURCE_COOKIE));
        var shouldRelabelFromGeo = !slSource || slSource === SOURCE_DEFAULT;
        if (shouldRelabelFromGeo) {
          var geoCandidate = getGeoCandidate();
          if (geoCandidate && geoCandidate.region === canonical.region) {
            canonical.source = SOURCE_GEO;
            if (geoCandidate.province && !canonical.province) {
              canonical.province = geoCandidate.province;
            }
          }
        }
      }
      applyCanonical(canonical, null);
    });
  }

  function handleSetRequest(e) {
    var detail = (e && e.detail) || {};
    var requestedSource = sourceToken(detail.source) || SOURCE_MANUAL;
    var canonical = buildCanonicalState({
      region: detail.region,
      country: detail.country,
      province: detail.province,
      source: requestedSource,
    });
    if (!canonical) return;

    var current = readPersisted();
    var currentRegion = current.region || DEFAULT_REGION;
    var currentCountry = current.country || DEFAULT_COUNTRY;
    var currentSource = sourceToken(current.source) || (current.region ? SOURCE_PERSISTED : SOURCE_DEFAULT);
    var incomingSource = sourceToken(canonical.source);

    if (sourcePriority(incomingSource) < sourcePriority(currentSource)) {
      logInfo('set-request ignored (lower precedence)', {
        incomingSource: incomingSource || '',
        currentSource: currentSource || '',
        incomingRegion: canonical.region,
        currentRegion: currentRegion,
      });
      return;
    }

    if (canonical.region === currentRegion && canonical.country === currentCountry) {
      if (isStrongerSource(incomingSource, currentSource)) {
        var upgradedSource = incomingSource;
        var upgradedState = buildCanonicalState({
          region: canonical.region,
          country: canonical.country,
          province: canonical.province,
          source: upgradedSource,
        });
        if (upgradedState) {
          writeState(upgradedState);
          window.ecomificRegionState = upgradedState;
          var fromSource = currentSource || '';
          logInfo('source upgraded', {
            from: fromSource,
            to: upgradedState.source,
            region: upgradedState.region,
            country: upgradedState.country,
          });
          dispatch(SOURCE_UPDATED_EVENT, {
            from: fromSource,
            to: upgradedState.source,
            region: upgradedState.region,
            country: upgradedState.country,
            province: upgradedState.province || '',
          });
        }
      }
      return;
    }

    var previous = {
      region: currentRegion,
      country: currentCountry,
      province: current.province || '',
      source: current.source || '',
    };
    writeState(canonical);
    window.ecomificRegionState = canonical;
    emitChanged(canonical, previous);
    syncCart(canonical.region).then(
      function () {
        emitReady(canonical);
        logInfo('Cart synced after set-request', canonical.region);
      },
      function (err) {
        emitReady(canonical);
        dispatch(SYNC_FAILED_EVENT, {
          region: canonical.region,
          country: canonical.country,
          source: canonical.source,
          message: (err && err.message) || 'Cart sync failed',
        });
      }
    );
  }

  if (!window.ecomific || typeof window.ecomific !== 'object') {
    window.ecomific = {};
  }
  if (!window.ecomific.regionCore || typeof window.ecomific.regionCore !== 'object') {
    window.ecomific.regionCore = {};
  }
  window.ecomific.regionCore.getState = getState;

  window.addEventListener(SET_REQUEST_EVENT, handleSetRequest);

  window.addEventListener('ecomific:region:ready', function (e) {
    if (!e || !e.detail || !e.detail.country) return;
    alignDomain(e.detail.country);
  });

  window.addEventListener('ecomific:region:changed', function (e) {
    if (!e || !e.detail || !e.detail.country) return;
    alignDomain(e.detail.country);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
